<template>
  <div class="date-selection-container" :class="customClass">
    <slick ref="slick1" :options="dateSelectionSlider">
      <div v-for="(dateLoop, loop) in dates" :key="loop">
        <!-- new Date(dateLoop) > new Date(currentDate) ? 'pointer-none' : -->
        <div
          v-on:click="onChangeTab(dateLoop)"
          :class="
            selectedDate == dateLoop
              ? 'active cursor-pointer'
              : allowPastBooking == 'Y'
              ? 'cursor-pointer'
              : new Date(currentDate) > new Date(dateLoop)
              ? 'cursor-pointer'
              : 'cursor-pointer'
          "
          class="date-slider-box"
        >
          <div class="text-center">
            <span>{{ dateLoop }}</span>
            <div class="lh-1" style="font-size:80%">
              {{ dateLoop | dayparse }}
            </div>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>

<script>
  import Slick from "vue-slick";
  import moment from "moment";
  import { EventBus } from "@/main";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      customClass: {
        type: String,
        default: "",
      },
      dateSelectionSlider: {
        type: Object,
        default: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 1,
        },
      },
      onChangeTab: {
        type: Function,
      },

      selectedTabIndex: {
        type: Number,
        default: 0,
      },
    },
    components: {
      Slick,
    },
    data() {
      return {
        currentDate: "",
        cinema_id: "",
      };
    },
    beforeMount() {},
    mounted() {
      this.currentDate = moment().format("DD-MM-YYYY");
      // this.getAllDates();
    },
    watch: {
      selectedTabIndex(newVal, oldVal) {
        if (newVal != oldVal) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
      },
    },
    computed: {
      dates() {
        if (this.$refs && this.$refs.slick1) {
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(2, true);
          });
        }
        return this.childComponents.getDatesArray;
      },
      allowPastBooking() {
        return "N";
      },
      selectedDate() {
        if (this.childComponents.isSlideSlick) {
          let getDateIndex = this.childComponents.getDatesArray.findIndex(
            (dateIndex) => {
              return dateIndex == this.childComponents.SELECTED_DATE;
            }
          );
          this.$refs.slick1.goTo(getDateIndex, true);
        }
        this.childComponents.isSlideSlick = false;
        return this.childComponents.SELECTED_DATE;
      },
    },
    methods: {},
  };
</script>

<style>
  .pointer-none {
    cursor: no-drop;
    pointer-events: none;
  }

  .width97 {
    width: 97% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/posDateSlider.vue